import { Col, FormGroup, Input, Label } from 'reactstrap';
import { InputProps } from '../../../../types/Forms';

const CommonInput: React.FC<InputProps> = ({
  colClass,
  id,
  placeholder,
  required,
  title,
  inputType,
  formGroup,
  floating,
  groupClass,
  labelClass,
  inputClass,
  value,
  onChange,
  disabled,
}) => {
  return (
    <Col className={colClass ? colClass : 'col-12'}>
      {!formGroup ? (
        <>
          <Label htmlFor={id} className={labelClass}>
            {title}
          </Label>
          <Input
            id={id}
            type={inputType}
            placeholder={placeholder}
            required={required}
            className={inputClass}
            value={value}
            onChange={onChange}
            autoComplete="off"
            disabled={disabled}
          />
        </>
      ) : (
        <>
          <FormGroup floating={floating} className={groupClass}>
            <Label htmlFor={id} className={labelClass}>
              {title}
            </Label>
            <Input
              id={id}
              type={inputType}
              placeholder={placeholder}
              required={required}
              className={inputClass}
              value={value}
              onChange={onChange}
              autoComplete="off"
              disabled={disabled}
            />
          </FormGroup>
        </>
      )}
    </Col>
  );
};

export default CommonInput;
